export default __webpack_public_path__ + "static/media/coloring_mouse.59390801.png";